


























































































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
  Divider,
} from "vant";
import WeMixin from "@/components/weMixin";
import api from "../../../components/http/api";
import { RegisterInfo } from "./UserApi";

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
    [Divider.name]: Divider,
  },
})
export default class UpdateUser extends mixins(WeMixin) {
  private registerInfo: RegisterInfo = {} as RegisterInfo;
  private buttonActive: boolean = false;

  private showOrg: boolean = false;
  private orgList = [
    {
      text: "江苏",
      orgId: "111111",
      children: [
        {
          text: "初始化",
          orgId: "111111",
          children: [{ text: "初始化", orgId: "111111" }],
        },
      ],
    },
  ];

  protected created() {
    this.getRegiserInfoById();
  }

  protected getRegiserInfoById() {
    const id: string = this.$route.params.id as string;
    this.registerInfo.id = id;
    api
      .post("/weixinmp/xsyx/myuser/getRegiserInfoById", this.registerInfo)
      .then((res: any) => {
        if (res.data.idno.length == 15) {
          res.data.idno = res.data.idno.replace(
            /^(.{6})(?:\d+)(.{4})$/,
            "$1******$2"
          );
        } else {
          res.data.idno = res.data.idno.replace(
            /^(.{6})(?:\d+)(.{4})$/,
            "$1********$2"
          );
        }
        console.log(
          "%cUserInfo.vue line:175 idno",
          "color: #007acc;",
          res.data.idno
        );
        res.data.phone = res.data.phone.replace(
          /(\d{3})\d{4}(\d{4})/,
          "$1****$2"
        );
        console.log(
          "%cUserInfo.vue line:179 phone",
          "color: #007acc;",
          res.data.phone
        );
        this.registerInfo = res.data;
        this.getOrgList();
        if (this.registerInfo.updateflag === "1") {
          this.buttonActive = true;
          this.$toast({
            message: "该账号已有修改记录，无法再次修改",
            position: "bottom",
          });
        }
      });
  }

  protected showOrgInfo() {
    if (this.registerInfo.updateflag === "0") {
      this.showOrg = true;
    }
  }

  protected getOrgList() {
    api.post("/weixinmp/xsyx/myuser/getOrgList", {}).then((res: any) => {
      this.orgList = res.data;
      const indexTmp = this.registerInfo.orgindex
        .replaceAll("[", "")
        .replaceAll("]", "");
      const indexList = indexTmp.split(",");
      this.$nextTick(() => {
        const vpRef = this.$refs.vpicker;
        // @ts-ignore
        vpRef.setColumnIndex(0, indexList[0]);
        // @ts-ignore
        vpRef.setColumnIndex(1, indexList[1]);
        // @ts-ignore
        vpRef.setColumnIndex(2, indexList[2]);
      });
    });
  }

  protected updateSubmit() {
    api
      .post("/weixinmp/xsyx/myuser/updateSubmit", this.registerInfo)
      .then((res: any) => {
        if (res.data.flag === "0") {
          Toast.success("修改成功");
          const interval = window.setInterval(() => {
            window.clearInterval(interval);
            this.$router.replace("/main/user/userInfo");
          }, 2000);
        } else if (res.data.flag === "1") {
          Toast.fail("修改失败，请联系工作人员");
        }
      });
  }

  protected onOrgConfirm(picker: any, index: any) {
    this.registerInfo.orgname = this.orgList[index[0]].children[
      index[1]
    ].children[index[2]].text;
    this.registerInfo.orgid = this.orgList[index[0]].children[
      index[1]
    ].children[index[2]].orgId;
    this.registerInfo.orgindex = index;
    this.showOrg = false;
  }
}
